import { isMetersUnit, isInchesUnit } from "../../../utils/height";
import {
  default as convert,
  UNIT_CM,
  UNIT_IN
} from "../../../utils/heightUnits";
import t from "../../../utils/translate";

const MIN_IN = 24;
const MAX_IN = 108;
const MIN_CM = convert(MIN_IN, UNIT_IN, UNIT_CM);
const MAX_CM = convert(MAX_IN, UNIT_IN, UNIT_CM);

function getInchesFeetInputConfig() {
  const feetLabel = t("HEIGHT_UNITS_FEET");
  const feetLabelShort = t("HEIGHT_UNITS_FEET_SHORT");
  const inchesLabel = t("HEIGHT_UNITS_INCHES");
  const inchesLabelShort = t("HEIGHT_UNITS_INCHES_SHORT");

  return {
    label: {
      feet: {
        placeholder: feetLabel,
        appended: feetLabel,
        appendedShort: feetLabelShort
      },
      inches: {
        placeholder: inchesLabel,
        appended: inchesLabel,
        appendedShort: inchesLabelShort
      }
    },
    min: {
      feet: 2,
      inches: 0,
      total: MIN_IN
    },
    max: {
      feet: 9,
      inches: 11.9,
      total: MAX_IN
    },
    mask: {
      feet: "0",
      inches: "00.0"
    }
  };
}

function getCentimetersInputConfig() {
  return {
    label: {
      appended: t("HEIGHT_UNITS_CENTIMETERS"),
      appendedShort: t("HEIGHT_UNITS_CENTIMETERS_SHORT")
    },
    min: MIN_CM,
    max: MAX_CM,
    mask: "000"
  };
}

function getMetersInputConfig() {
  return {
    label: {
      appended: t("HEIGHT_UNITS_METERS_SHORT"),
      appendedShort: t("HEIGHT_UNITS_METERS_SHORT")
    },
    min: MIN_CM / 100,
    max: MAX_CM / 100,
    mask: "0.00"
  };
}

export default function useHeightInputConfig(unit) {
  switch (true) {
    case isInchesUnit(unit):
      return getInchesFeetInputConfig();

    case isMetersUnit(unit):
      return getMetersInputConfig();

    default:
      return getCentimetersInputConfig();
  }
}
